export default __webpack_public_path__ + "static/media/pen-intro-sweets.e9e0f5ee.png";